<template>
  <div
    class="uploadBox"
    ref="uploadRef"
    @click.prevent
    @dragover="handleDragover"
    @drop="handleDrop"
  >
    <div class="upload-content">
      <p class="ant-upload-drag-icon">
        <!-- <inbox-outlined></inbox-outlined> -->
        <img :src="uploadIcon" />
      </p>
      <p class="ant-upload-text">
        {{ $t("fileUploadPrompt") }}
        <a-upload :multiple="true" :customRequest="handleCustomRequest" :fileList="[]">
          <span
            class="local-file"
            style="color: #1890ff; cursor: pointer; font-size: 18px"
            >{{ $t("localFileUpload") }}</span
          >
        </a-upload>
      </p>
      <div>
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, defineEmits, onBeforeUnmount } from "vue";
import { getFileMD5 } from "./utils";
import { FileInfo } from "./type";
// import { InboxOutlined } from "@ant-design/icons-vue";
import uploadIcon from "./icon/upload.png";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const uploadRef = ref();
const emit = defineEmits(["change"]);
const { getMountContent } = withDefaults(
  defineProps<{
    beforeUpload?: (file: File) => Promise<any>;
    getMountContent?: () => HTMLElement;
  }>(),
  {}
);
const addedListeners = new WeakSet();

function addListenerIfNotPresent(
  element: any,
  eventName: string,
  listener: (event: any) => void
) {
  if (!addedListeners.has(listener)) {
    element.addEventListener(eventName, listener);
    addedListeners.add(listener);
  }
}
function handlePaste(event: any) {
  const items = event.clipboardData?.items;
  if (items) {
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.kind === "file") {
        const file = item.getAsFile();
        console.log(item.kind, "item.kind");
        uploadFile(file);
      }
    }
  }
}
async function uploadFile(file: File) {
  const fileKey = getFileMD5(file);
  const SelectFileInfo: FileInfo = {
    fileKey: fileKey,
    fileName: file.name,
    file: file,
    fileUrl: function (fileUrl: any): unknown {
      throw new Error("Function not implemented.");
    },
    progress: 0,
    status: "",
  };
  emit("change", SelectFileInfo);
}

function handleDragover(e: any) {
  e.preventDefault();
}

function handleDrop(e: any) {
  e.preventDefault();
  // 获取拖放的文件列表
  const { files } = e.dataTransfer;
  if (files && files.length) {
    for (const item of files) {
      uploadFile(item);
    }
  }
}

async function handleCustomRequest({ file }: any) {
  uploadFile(file);
}

onMounted(() => {
  let elm = document.body;
  if (getMountContent) {
    elm = getMountContent();
  }
  addListenerIfNotPresent(elm, "paste", handlePaste);
});
onBeforeUnmount(() => {
  let elm = document.body;
  if (getMountContent) {
    elm = getMountContent();
  }
  if (elm) {
    elm.removeEventListener("paste", handlePaste);
  }
});
</script>
<style lang="scss" scoped>
.uploadBox {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 5px;
}

.uploadBox:hover {
  border: 1px dashed #1890ff;
}

.upload-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  padding: 18px;
}

.ant-upload-drag-icon {
  font-size: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 18px;
  color: #1890ff;

  > img {
    position: relative;
    width: 60px;
  }
}

.ant-upload-text {
  position: relative;
  font-size: 18px;
}

// .uploadBox .ant-upload.ant-upload-drag .ant-upload-btn {
//   position: relative;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// }
</style>
